import { render } from "./RegisterCustomerPaymentForm.vue?vue&type=template&id=849ac28a&scoped=true"
import script from "./RegisterCustomerPaymentForm.vue?vue&type=script&lang=js"
export * from "./RegisterCustomerPaymentForm.vue?vue&type=script&lang=js"

import "./RegisterCustomerPaymentForm.vue?vue&type=style&index=0&id=849ac28a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2981498683/src/lrex-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-849ac28a"]])

export default __exports__